/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Not_The_Managing_GroupInputs */

const en_us2_plan_not_the_managing_group = /** @type {(inputs: Plan_Not_The_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach manages this plan, so it cannot be changed here.`)
};

const pt_br2_plan_not_the_managing_group = /** @type {(inputs: Plan_Not_The_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem cuida deste plano é seu treinador, então ele não pode ser alterado aqui.`)
};

const es_419_plan_not_the_managing_group = /** @type {(inputs: Plan_Not_The_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador administra este plan, así que no se puede cambiar aquí.`)
};

const pt_pt2_plan_not_the_managing_group = /** @type {(inputs: Plan_Not_The_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem gere este plano é o teu treinador, por isso não pode ser alterado aqui.`)
};

const fr_fr2_plan_not_the_managing_group = /** @type {(inputs: Plan_Not_The_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est ton coach qui gère ce programme, il ne peut donc pas être modifié ici.`)
};

const de_de2_plan_not_the_managing_group = /** @type {(inputs: Plan_Not_The_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach verwaltet diesen Plan, daher kann er hier nicht geändert werden.`)
};

const it_it2_plan_not_the_managing_group = /** @type {(inputs: Plan_Not_The_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa scheda è gestita dal tuo coach, quindi non può essere modificata qui.`)
};

/**
* | output |
* | --- |
* | "Your coach manages this plan, so it cannot be changed here." |
*
* @param {Plan_Not_The_Managing_GroupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_not_the_managing_group = /** @type {((inputs?: Plan_Not_The_Managing_GroupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Not_The_Managing_GroupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_not_the_managing_group(inputs)
	if (locale === "es-419") return es_419_plan_not_the_managing_group(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_not_the_managing_group(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_not_the_managing_group(inputs)
	if (locale === "de-DE") return de_de2_plan_not_the_managing_group(inputs)
	if (locale === "it-IT") return it_it2_plan_not_the_managing_group(inputs)
	return en_us2_plan_not_the_managing_group(inputs)
});
export { plan_not_the_managing_group as "plan.not_the_managing_group" }